import { useEffect, useState } from 'react'
import { cachedGet } from '../lib/api.js'
import { asList } from '../lib/datetime.js'
import { Select } from './Picker.jsx'
import { filterBranchOptions, formBranchOptions } from './branches.js'

/**
 * The branch picker (decision #2). Loads /api/branches once per session.
 *
 *   mode 'filter' (default) — first option ทุกสาขา (''); อารีย์ also covers สนามเป้า.
 *                             Turn the value into ids with branchFilterIds() before querying.
 *   mode 'form'             — real clinic branches only, no "all".
 * Head office is never in either list.
 */
export function useBranches() {
  const [branches, setBranches] = useState([])
  useEffect(() => {
    let alive = true
    cachedGet('/api/branches').then((r) => { if (alive) setBranches(asList(r)) }).catch(() => {})
    return () => { alive = false }
  }, [])
  return branches
}

export function BranchSelect({ mode = 'filter', value, onChange, branches: given, allLabel, placeholder, ...rest }) {
  const loaded = useBranches()
  const branches = given || loaded
  const options = mode === 'form' ? formBranchOptions(branches) : filterBranchOptions(branches, { allLabel })
  return (
    <Select value={value} onChange={onChange} options={options}
      placeholder={placeholder || (mode === 'form' ? 'เลือกสาขา…' : 'ทุกสาขา')} {...rest} />
  )
}
